let folder = 'insights'
export const state = () => ({
  meta: null,
  content: null,
  author: null,
  more: null,
  generalInformation: null,
  relatedArticles: [],
  contact: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  content(state) {
    return state.content
  },
  author(state) {
    return state.author
  },
  generalInformation(state) {
    return state.generalInformation
  },
  more(state) {
    return state.more
  },
  relatedArticles(state) {
    let articles = []
    return state.relatedArticles.filter((article) => {
      if (!articles.includes(article.folderName)) {
        articles.push(article.folderName)
        return true
      }
      return false
    })
  },
  contact(state) {
    return state.contact
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setAdditionalInformation(state, { index, pth }) {
    state.content.paragraphs = state.content.paragraphs.map(
      (paragraph, idx) => {
        if (idx == index) {
          paragraph.src = pth
        }
        return paragraph
      }
    )
  },
  setContent(state, { data }) {
    if (data && data.paragraphs) {
      if (typeof data.paragraphs.assign !== 'undefined') {
        let paragraphsCopy = Object.assign({}, data.paragraphs)
        data.paragraphs = [paragraphsCopy]
      }
      data.paragraphs = data.paragraphs.map((paragraph) => {
        paragraph.has_image = paragraph.has_image == 'TRUE'
        return paragraph
      })
    }
    state.content = data
    if (process.client && window) {
      window.dispatchEvent(new CustomEvent('checkAvailableImages'))
    }
  },
  setAuthor(state, { data }) {
    state.author = data
  },
  setGeneralInformation(state, { data }) {
    state.generalInformation = data
  },
  setMore(state, { data }) {
    state.more = data
  },
  setRelatedArticles(state, { data, reset, folderName }) {
    if (reset) {
      state.relatedArticles = []
    } else if (folderName) {
      data.folderName = folderName
      state.relatedArticles.push(data)
    }
  },
  setContact(state, { data }) {
    state.contact = data
  }
}
export const actions = {
  getMeta({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/meta.json`
      )
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/content.json`
      )
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAuthor({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/author.json`
      )
      .then((res) => {
        commit('setAuthor', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getGeneralInformation({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/general_information.json`
      )
      .then((res) => {
        commit('setGeneralInformation', { data: res.data })
        return res
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMore({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/more.json`
      )
      .then((res) => {
        commit('setMore', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getRelatedArticles({ commit, rootState }, { folderName }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${folderName}/general_information.json`
      )
      .then((res) => {
        commit('setRelatedArticles', { data: res.data, folderName: folderName })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }, { articleFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${articleFolder}/contact.json`
      )
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
